import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { config } from '../config';
import PaymentStatus from '../components/Wizard_V2/Steps/ReviewAndPay/PaymentStatus'

const stripePromise = loadStripe(config.stripe.publishableKey);

const PaymentStatusPage = () => {
  return (
    <Elements stripe={stripePromise}>
      <PaymentStatus />
    </Elements>
  );
};

export default PaymentStatusPage;
